import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks the deletion of the API key',
  name: 'account_api_key_delete',
  params: [
    {
      description: 'The ID of the API key',
      name: 'api_key_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
